<template>
    <kt-panel>
        <div class="card-body">
            <kt-form-section>
                <kt-form-row>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="referenceId">
                                {{ $t('statements-report.trace') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="DateFrom"
                                    name="DateFrom"
                                    id="DateFrom"
                                    v-model="query.trace"
                                    dir="ltr"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="switchTraceNo">
                                {{ $t('statements-report.rrn') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="rrn"
                                    name="rrn"
                                    id="rrn"
                                    v-model="query.rrn"
                                    dir="ltr"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="maxAmount">
                                {{ $t('statements-report.amount') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="maxAmount"
                                    dir="ltr"
                                    name="maxAmount"
                                    id="maxAmount"
                                    v-model="query.amount"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="card_number">
                                {{ $t('label.card_number') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="card_number"
                                    name="card_number"
                                    id="card_number_input"
                                    style="direction:ltr"
                                    v-model="query.card_number"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="from_date">
                                {{ $t('label.from_date') }}
                            </kt-form-label>
                            <button id="reset_from_date"
                                    @click="clearFromDate"
                                    class="btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                    input-class="form-control"
                                    id="from_date"
                                    name= "from_date"
                                    v-model="query.from_date"
                                    :editable="!! query.from_date"
                                    type="datetime"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="to_date">
                                {{ $t('label.to_date') }}
                            </kt-form-label>
                            <button id="reset_to_date"
                                    @click="clearToDate"
                                    class="btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                    input-class="form-control"
                                    id="to_date"
                                    name= "to_date"
                                    v-model="query.to_date"
                                    :editable="!! query.to_date"
                                    type="datetime"
                            />
                        </kt-form-group>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
            <kt-form-section>
                <kt-row>
                    <kt-col xs="12" sm="6" md="6">
                        <button class="btn btn-success btn-wide" @click="action($event, query)">
                            {{ $t('transactions-report.send-request') }}
                        </button>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="6">
                        <button
                            class="btn btn-success btn-wide float-right"
                            size="md"
                            type="button"
                            id="export_psp_transations_btn"
                            @click="exportExcel($event, query)"
                        >
                            {{ $t('btn.export_transaction_to_excel') }}
                        </button>
                    </kt-col>
                </kt-row>
            </kt-form-section>
        </div>
    </kt-panel>
</template>
<script>

    import Inputmask from "inputmask";

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            exportExcel: {
                default: function(e, query) {},
                required: true,
            }
        },
        mounted() {
            setTimeout( function () {
                Inputmask("9999-9999-9999-9999").mask(document.querySelectorAll('#card_number_input'))
            }, 5000)
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
        },
        data() {
            return {
                query: {
                    'shop_type': 'dedicated'
                }
            }
        }
    }
</script>

<style>

</style>